import { forwardRef, useId } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const Home01Bold = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    const clipId = useId();
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <path
                        d="M20.46 7.69018L14.46 3.02018C13.02 1.90018 10.99 1.90018 9.55 3.02018L3.55 7.69018C2.57 8.45018 2 9.61018 2 10.8502V18.0002C2 20.2102 3.79 22.0002 6 22.0002H18C20.21 22.0002 22 20.2102 22 18.0002V10.8502C22 9.61018 21.43 8.45018 20.46 7.69018ZM15 17.7502H9C8.59 17.7502 8.25 17.4102 8.25 17.0002C8.25 16.5902 8.59 16.2502 9 16.2502H15C15.41 16.2502 15.75 16.5902 15.75 17.0002C15.75 17.4102 15.41 17.7502 15 17.7502Z"
                        fill="white"
                        style={{ fill: "var(--fillg)" }}
                    />
                </g>
                <defs>
                    <clipPath id={clipId}>
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
});
